import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";

import { kisiQueryKeys } from "./kisiQueryKeys";

export function useQueryKisiGroupList(
  { api }: { api: ApiType },
  queryOpts?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: kisiQueryKeys.groups(),
    queryFn: async () => {
      const result = await api.kisiApi.fetchGroups();
      return result.data;
    },
    ...queryOpts,
  });
}
